export const formatAsCurrency = amount => {
  return Number(amount).toLocaleString('de-DE', { minimumFractionDigits: 2 });
};

export const calculateAmount = (amount, amountCollected) => {
  return formatAsCurrency(amount - amountCollected);
};



// WEBPACK FOOTER //
// ./src/Helper.js